module.exports = __webpack_public_path__ + "img/key_features--safety.e8270c72.jpg";